/* eslint-disable @typescript-eslint/no-non-null-assertion */
declare global {
  interface Window {
    __configuration__: Record<string, string>;
  }
}
window.__configuration__ = window.__configuration__ || {};

interface PortalConfiguration {
  apiUrl: string; // REACT_APP_API_URL=https://api.ecomm.reecedev.us/
  // Application name sent to the gateway IdP discovery endpoint (?app=<name>).
  appName: string; // REACT_APP_APP_NAME=wms-admin-portal
  // Gateway IdP discovery endpoint (dual-IdP migration window).
  gatewayUrl: string; // REACT_APP_GATEWAY_URL=https://workplace-gateway.internal-dev.reecedev.us
  gatewayBasicAuthToken: string; // REACT_APP_GATEWAY_BASIC_AUTH_TOKEN=<base64(user:pass)>
  // Entra ID (MSAL) — used when the discovery endpoint returns "entra".
  azureClientId: string; // REACT_APP_AZURE_CLIENT_ID
  azureTenantId: string; // REACT_APP_AZURE_TENANT_ID
  // Access-token scope for this SPA's Entra app registration. Infra configures group
  // claims on the access token for api://<client-id>/access_as_user (not internal-api).
  apiScope: string; // REACT_APP_API_SCOPE
  // Okta — used when the discovery endpoint returns "okta". TEMPORARY (migration window).
  oktaUrl: string; //   REACT_APP_OKTA_URL=https://dev-432546.okta.com
  oktaClientId: string; //   REACT_APP_OKTA_CLIENT_ID=0oa13b0b5bMKXZfJU4x7
  oktaScopes: string;
  countPollingInterval: string; //  REACT_APP_COUNT_POLLING_INTERVAL=1500
}

export const Configuration: PortalConfiguration /* & TestConfiguration */ = {
  apiUrl: window.__configuration__.REACT_APP_API_URL!,
  appName: window.__configuration__.REACT_APP_APP_NAME || "wms-admin-portal",
  gatewayUrl: window.__configuration__.REACT_APP_GATEWAY_URL!,
  gatewayBasicAuthToken: window.__configuration__.REACT_APP_GATEWAY_BASIC_AUTH_TOKEN!,
  azureClientId: window.__configuration__.REACT_APP_AZURE_CLIENT_ID!,
  azureTenantId: window.__configuration__.REACT_APP_AZURE_TENANT_ID!,
  apiScope:
    window.__configuration__.REACT_APP_API_SCOPE ||
    "api://2d1db1c5-cf58-4f52-86ff-b4dbd1cb2f36/access_as_user",
  oktaUrl: window.__configuration__.REACT_APP_OKTA_URL!,
  oktaClientId: window.__configuration__.REACT_APP_OKTA_CLIENT_ID!,
  oktaScopes: window.__configuration__.REACT_APP_OKTA_SCOPES,
  countPollingInterval: window.__configuration__.REACT_APP_COUNT_POLLING_INTERVAL,
};

export const oktaAuthOptions = {
  clientId: Configuration.oktaClientId || "{clientId}",
  issuer:
    Configuration.oktaUrl || "https://{yourOktaDomain}.com/oauth2/default",
  redirectUri: `${window.location.origin}/`,
  scopes: ["openid", "profile", "email", "groups"],
  countPollingInterval: "1500",
};
